import React from 'react';

import { useFilterStorage } from 'src/hooks/common';
import { usePeoStaffList, usePeoStaffListQueryVariables } from 'src/hooks/peoStaff';
import { ResendInviteModal } from 'src/modals/invite';
import { InvitePeoStaffByPeoPayrollProviderModal } from 'src/modals/peoStaff';

import { PeoStaffTable } from '../PeoStaffTable';

interface PeosDetailsStaffTablePeoPayrollProviderProps {
  peoId: string | undefined;
}

export const PeosDetailsStaffTablePeoPayrollProvider: React.FC<
  PeosDetailsStaffTablePeoPayrollProviderProps
> = ({ peoId }) => {
  const { pagination } = useFilterStorage();

  const queryVariables = usePeoStaffListQueryVariables(peoId);
  const { peoStaffsList, peoStaffsCount, loading, refetch } = usePeoStaffList(
    queryVariables,
    !peoId,
    true,
  );

  const refetchData = React.useCallback(async () => {
    await refetch();
    pagination.resetPage();
  }, [pagination, refetch]);

  return (
    <React.Fragment>
      <PeoStaffTable
        peoStaffList={peoStaffsList}
        peoStaffCount={peoStaffsCount}
        onRefresh={refetchData}
        pagination={pagination}
        loading={loading}
      />

      <InvitePeoStaffByPeoPayrollProviderModal />
      <ResendInviteModal />
    </React.Fragment>
  );
};
